export default "__VITE_ASSET__Dx_2URFx__"